import React from 'react';
import StarBlue from '../../asset/StarBlue.png';

export default function PricingPlan() {
    const scrollToBookATour = () => {
        const element = document.getElementById('book-a-tour');
        if (element) {
            const headerHeight = 105;
            const elementPosition = element.offsetTop - headerHeight;

            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth',
            });
        }
    };

    return (
        <div
            style={{ borderRadius: '20px' }}
            className="bg-[#0B2342] items-center p-4 sm:p-8 relative sm:h-[270px] justify-center sm:mx-8 sm:px-8 my-8"
        >
            <div className="flex flex-col sm:flex-row w-full items-center sm:justify-between gap-6">
                {/* Left Section */}
                <div className="w-full sm:w-[33%] font-regrade px-4 sm:px-8 font-semibold text-white text-center sm:text-left">
                    <p className="text-[16px] sm:text-[18px]">TRANSPARENT PRICING</p>
                    <p className="text-[32px] sm:text-[48px]">Simple Plans.</p>
                    <p className="text-[32px] sm:text-[48px]">No Surprises.</p>
                    <p className="text-[14px] sm:text-[16px] font-normal">No Deposit. No Lock-In</p>
                </div>

                {/* Middle Pricing Box */}
                <div
                    style={{ border: '1.93px solid #C37FEDD4', borderRadius: '20px' }}
                    className="px-6 sm:px-8 py-4 bg-[#172d49] w-full sm:w-auto flex flex-col justify-center text-center"
                >
                    <p className="text-[#C37FED] text-[36px] sm:text-[46px] font-semibold">Annual</p>
                    <p className="text-white text-[32px] sm:text-[45px] font-sans font-semibold">
                        ₹14,999<span className="text-[20px] sm:text-[27px]">/year</span>
                        <span className="text-[14px] sm:text-[16px] font-normal">+GST</span>
                    </p>
                    <p className="text-[18px] sm:text-[27px] font-semibold text-[#19B796]">(No Extra)</p>
                </div>

                {/* Right Bullet Points */}
                <div className="w-full sm:w-[33%] text-white flex flex-col justify-center gap-4 px-4 sm:px-8 text-center sm:text-left">
                    <div className="flex items-start gap-2 justify-center sm:justify-start">
                        <span className="text-[20px] sm:text-[24px]">•</span>
                        <p className="text-[16px] sm:text-[20px] font-semibold">GST & ROC Documents</p>
                    </div>
                    <div className="flex items-start gap-2 justify-center sm:justify-start">
                        <span className="text-[20px] sm:text-[24px]">•</span>
                        <p className="text-[16px] sm:text-[20px] font-semibold">Call & Mail Handling</p>
                    </div>
                    <div className="flex items-start gap-2 justify-center sm:justify-start">
                        <span className="text-[20px] sm:text-[24px]">•</span>
                        <p className="text-[16px] sm:text-[20px] font-semibold">Meeting Room Credits</p>
                    </div>
                </div>

                {/* Button */}
                <div className="mt-4 sm:mt-0">
                    <button
                        onClick={scrollToBookATour}
                        className="flex items-center mx-auto sm:mx-0 h-fit whitespace-nowrap text-[12px] sm:text-[14px] font-semibold rounded-full px-4 sm:px-5 py-2 bg-white text-[#232B6E] shadow-md hover:bg-gray-100 transition-colors"
                    >
                        <img className="h-[10px] w-[10px] mr-2" src={StarBlue} alt="star" />
                        Book Now!
                    </button>
                </div>
            </div>
        </div>
    );
}
